import { memo } from 'react'
import OrderActionsOnChart from './OrderActionsOnChart/OrderActionsOnChart'
import ChartAlertActions from './ChartAlertActions/ChartAlertActions'
import ChartDrawingSettings from './chartDrawingSettings/chartDrawingSettings'
import OiProfileTooltip from './oiProfileTooltip/oiProfileTooltip'
import ContractsTooltip from './contractsTooltip/ContractsTooltip'

type Props = {
    chartId: string
}

const ChartOverlays = ({ chartId }: Props) => (
    <>
        <ChartDrawingSettings chartId={chartId} />
        <OiProfileTooltip chartId={chartId} />
        <ContractsTooltip chartId={chartId} />
        <OrderActionsOnChart chartId={chartId} />
        <ChartAlertActions chartId={chartId} />
    </>
)

export default memo(ChartOverlays)
